import { createAction, props } from '@ngrx/store';
import { TradeOption } from 'domain-entities';

export const setTradeOptionsActions = createAction(
	'[Trade Options] Set Trade Options',
	props<{ options: TradeOption[] }>(),
);
export const initTradeOptionsActions = createAction('[Trade Options] Init Trade Options');
